// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logoCss_ljbhas3{display:block;margin:0 -8px 2px;}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-footer/dist/es/FooterExpansionContent/SocialSection/FSLogo.css"],"names":[],"mappings":"AAAA,iBAAiB,aAAa,CAAC,iBAAiB,CAAC","sourcesContent":[".logoCss_ljbhas3{display:block;margin:0 -8px 2px;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
